import Parse from 'parse';

const EmployeeModule = {
  namespaced: true,
  state: {
    vacationDays: null,
    vacationDaysNextYear: 0,
  },
  mutations: {
    setVacationDays(state, days) {
      state.vacationDays = days;
    },
    setVacationDaysNextYear(state, days) {
      let ee = 0;
      if (days.vacationDaysPerMonthPerYear[`${new Date().getFullYear() + 1}`]) {
        ee = Object.values(days.vacationDaysPerMonthPerYear[`${new Date().getFullYear() + 1}`]).reduce(
          (a, b) => a + b,
          0
        );
      }
      state.vacationDaysNextYear = ee;
    },
  },
  actions: {
    async getVacationDays({ commit }, userId = null) {
      const date = new Date();
      const month = date.getMonth();
      const year = new Date().getFullYear();
      try {
        const days = await Parse.Cloud.run('getVacationDays', { month, year, userId }, {});
        commit('setVacationDays', days);
        commit('setVacationDaysNextYear', days);
      } catch (e) {
        console.log(e);
      }
    },
  },
  getters: {
    vacationDays: (state) => state.vacationDays,
    vacationDaysNextYear: (state) => state.vacationDaysNextYear,
  },
};
export default EmployeeModule;
